import React from "react";
import { Switch, Route, RouteComponentProps } from "react-router";
import Login from "../../pages/Login";
import SignUp from "pages/Signup";
import { View } from "ui";
import { InstallApp, Header, Footer } from "components";
import Presentation from "../../pages/Presentation";
import Faq from "../../pages/Faq";
import TermsOfService from "../../pages/TermsOfService";
import Contact from "../../pages/Contact";
import ForgotPassword from "pages/ForgotPassword";
import Homepage from "./Homepage";
import PresentationModal from "pages/PresentationModal";

export default ({ match }: RouteComponentProps) => {

  return (
    <React.Fragment>
      <View pl={5} flexDirection="row" justifyContent="space-between">
        <View flex={1} flexDirection="column">
          <Header/>
          <Switch>
            <Route path="/signup" component={SignUp} />
            <Route path="/forgot-password" component={ForgotPassword} />
            <Route path="/faq" component={Faq} />
            <Route path="/tos" component={TermsOfService} />
            <Route path="/contact" component={Contact} />
            <Route path="/login" component={Login} />
            <Route path="/" component={Homepage} />
          </Switch>
          <Route
            path="/prezentare"
            render={(p) => (
              <PresentationModal open onClose={() => p.history.push("/")} />
            )}
          />
          <Route
            path="/*/prezentare"
            render={(p) => (
              <PresentationModal open onClose={() => p.history.push(p.location.pathname.replace("/prezentare", ""))} />
            )}
          />
          <View mt={2}>
            <Footer />
          </View>
        </View>
        <InstallApp />
      </View>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/routes/public/Public.tsx